import styled from "styled-components";

export const Container = styled.div<{ backgroundColor?: string }>`
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    background: ${({ theme, backgroundColor }) =>
        backgroundColor || theme.colors[theme.colorMode].background_Secondary};
`;

export const HeaderContainer = styled.div<{ backgroundColor?: string; background?: string }>`
    background-color: ${({ theme, backgroundColor }) =>
        backgroundColor || theme.colors[theme.colorMode].background_Secondary};
    position: relative;
    background: ${({ background }) => background || "transparent"};

    @supports (padding-top: var(--sat)) {
        padding-top: var(--sat, 0px);
    }
`;

export const ContentWrapper = styled.div<{ backgroundColor?: string; headerHeight?: number }>`
    height: ${({ headerHeight }) =>
        headerHeight ? `calc(100% - ${headerHeight}px + var(--sab, 0px))` : "calc(100% + var(--sab, 0px))"};
    background-color: ${({ backgroundColor }) => backgroundColor || "transparent"};
    flex: 1;

    @supports (-webkit-touch-callout: none) {
        @supports (padding-bottom: env(safe-area-inset-bottom)) {
            height: ${({ headerHeight }) =>
                headerHeight
                    ? `calc(100% - ${headerHeight}px + env(safe-area-inset-bottom, 0px))`
                    : `calc(100% + env(safe-area-inset-bottom, 0px))`};
        }
    }
`;

export const ContentContainer = styled.div<{
    backgroundColor?: string;
    borderRadius?: string;
    footerHeight?: number;
    extraBottomPadding?: number;
}>`
    flex: 1;
    overflow-x: hidden;
    overflow-y: scroll;
    overscroll-behavior: none;
    border-radius: ${({ borderRadius }) => borderRadius || "0"};
    background-color: ${({ theme, backgroundColor }) =>
        backgroundColor || theme.colors[theme.colorMode].background_Secondary};
    height: 100%;
    padding-bottom: calc(var(--cart-footer-height, 0px) + ${({ extraBottomPadding }) => extraBottomPadding || 0}px);
`;
